import { client } from '../client';
import { IOneReport } from './types/IOneReport';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

export const deleteOneReportMedia = async (
  one_report_id: string,
  one_report_media_id: string,
  userRole?: string,
): Promise<IOneReport> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const { data } = await client.delete<IOneReport>(
    `${prefix}/one_reports/${one_report_id}/media/${one_report_media_id}`,
  );

  return data;
};
